// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"524":"bb86940027af9f739fe3","612":"6cca957a3cbb90e715bb"}[chunkId] + ".js";
};